<template>
  <div class="col-12 text-center" v-if="Object.keys(order).length > 0 && Object.keys(orderLocation).length > 0">

    <m-a target="_blank" :href="qrValue">
      <vue-qr :size="250" class="qrTag" ref="qrTag" :text="qrValue"/>
      <span v-t="`order_location.order_location_qr_text`" class="text-dark"></span>
    </m-a>

  </div>
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import MA from '../../../Tags/A.vue'

export default {
  name: "OrderLocation1",
  components: {vueQr, MA},
  props: {
    order: {
      default: null
    }
  },
  computed: {
    orderLocation() {
      return this.order.meta.find(item => {
        if (item.name == 'order_location') {
          return item
        }
      })
    },
    qrValue() {
      return `https://www.google.com/maps/dir/?api=1&destination=${this.orderLocation.value}`
    }
  }
}
</script>

<style scoped>

</style>